import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';

import paths from 'routes/routes';

import LoadingScreen from '@src/components/loading-screen';
import AuthLayout from '@src/layouts/auth';
import ForgotPassword from '@src/pages/forgot-password';
import GuestGuard from '@src/routes/components/guest-guard';

const SignInPage = lazy(() => import('@src/pages/sign-in'));
const SignUpPage = lazy(() => import('@src/pages/sign-up'));

const authRoutes = [
  {
    path: paths.root,
    element: (
      <Suspense fallback={<LoadingScreen />}>
        <GuestGuard>
          <AuthLayout>
            <Outlet />
          </AuthLayout>
        </GuestGuard>
      </Suspense>
    ),
    children: [
      {
        path: paths.signIn,
        element: <SignInPage />,
      },
      {
        path: paths.signUp,
        element: <SignUpPage />,
      },
      {
        path: paths.forgotPassword,
        element: <ForgotPassword />,
      },
    ],
  },
];

export default authRoutes;
